import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useRefreshToken from './useRefreshToken';
import { apiAxios, fileAxios } from 'utils/axios';

// const useAxios = () => {
// 	const accessToken = useSelector((state) => state.auth.accessToken);
// 	const refresh = useRefreshToken();

// 	useEffect(() => {
// 		const requestInterceptor = axios.interceptors.request.use(
// 			(config) => {
// 				if (!config.headers['Token']) {
// 					config.headers['Token'] = `Bearer ${accessToken}`;
// 				}
// 				return config;
// 			},
// 			(error) => {
// 				// console.log("error", error);
// 				return Promise.reject(error);
// 			}
// 		);

// 		const responseInterceptor = axios.interceptors.response.use(
// 			(response) => response,
// 			async (error) => {
// 				if (error?.response?.status === 401 && !error?.config?.send) {
// 					error.config.send = true;
// 					const newAccessToken = await refresh();
// 					error.config.headers['Token'] = `Bearer ${newAccessToken?.id_token}`;
// 					return axios(error.config);
// 				}

// 				return Promise.reject(error);
// 			}
// 		);

// 		return () => {
// 			axios.interceptors.request.eject(requestInterceptor);
// 			axios.interceptors.response.eject(responseInterceptor);
// 		};
// 	}, [accessToken, refresh]);

// 	return axios;
// };

const useAxios = () => {
	const accessToken = useSelector((state) => state.auth.accessToken);
	const refresh = useRefreshToken();

	useEffect(() => {
		// Attach interceptors to both instances
		const attachInterceptors = (instance) => {
			// Request interceptor
			const reqInterceptor = instance.interceptors.request.use(
				(config) => {
					if (!config.headers['Authorization'] && accessToken) {
						config.headers['Authorization'] = `Bearer ${accessToken}`;
					}
					return config;
				},
				(error) => Promise.reject(error)
			);

			// Response interceptor
			const resInterceptor = instance.interceptors.response.use(
				(response) => response,
				async (error) => {
					const prevRequest = error?.config;
					if (error?.response?.status === 401 && !prevRequest._retry) {
						prevRequest._retry = true;
						const newAccessToken = await refresh();
						if (newAccessToken?.id_token) {
							prevRequest.headers['Authorization'] = `Bearer ${newAccessToken.id_token}`;
							return instance(prevRequest);
						}
					}
					return Promise.reject(error);
				}
			);

			// Cleanup function
			return () => {
				instance.interceptors.request.eject(reqInterceptor);
				instance.interceptors.response.eject(resInterceptor);
			};
		};

		// Attach to both instances
		const cleanupApi = attachInterceptors(apiAxios);
		const cleanupFile = attachInterceptors(fileAxios);

		// Cleanup on unmount
		return () => {
			cleanupApi();
			cleanupFile();
		};
	}, [accessToken, refresh]);

	// Return both instances so you can choose
	return { apiAxios, fileAxios };
};

export default useAxios;
